<script lang="ts" context="module">
	export const KEY_OCCASION = 'occasion';
</script>
<script lang="ts">
	import type { LandingItemContext, RealBanner } from "$lib/def/landing";

	import { page } from "$app/stores";
	import { fetch$ } from "$lib/serv/core/cache";
	import { getDB, SPKEYS } from "$lib/serv/groc-landing";
	import { query } from "$lib/util/url";
	import { EMPTY } from "rxjs";
	import { getContext } from "svelte";
	
	import Landing from "./Landing.svelte";
	import Grid from "$lib/ui/layout/Grid.svelte";

	export let endpoint: string | undefined;
	export let store: string | null;
	export let occasion: string | undefined | null;

	const { landingItems, cacheAge } = getContext('endpoints') as LandingItemContext;

	$: cache = endpoint ? fetch$<RealBanner[]>(new URL(landingItems + endpoint), SPKEYS, { db: getDB(), msMaxCacheAge: cacheAge.medium }) : EMPTY;

</script>

<Grid cache={$cache} type="occasions" key={(payload) => payload} grid={!query($page.url).has(KEY_OCCASION)} let:item={banner} id="occasions">
	{#if occasion && banner.uuid === occasion}
		<Landing {store} item={banner} on:product />
	{:else if !occasion}
		<a href={`/?${query($page.url).set(KEY_OCCASION, banner.uuid)}`}
			class="item"
			class:cropped={banner.cropped}
			class:portrait={banner.portrait}
			class:image_only={banner.image_only}
			style="
				background-color: {banner.colours?.background};
				color: {banner.colours?.title};
				background-image: url({banner.image?.base_url + '/' + banner.image?.filename});
			">
			{#if banner.title}<h4 class="title body-l bold">{banner.title}</h4>{/if}
		</a>
	{/if}
</Grid>
